<template>
  <div class="page">
        <!-- 搜索 -->
<!--  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>-->
<!--              <el-form-item label="名称">-->
<!--                  <el-input  v-model="queryForm.categoryName"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="父ID">-->
<!--                  <el-input  v-model="queryForm.parentId"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item>-->
<!--                  <el-button size="small" type="primary" icon="el-icon-search" @click="getEduExampaperCategoryList">查询</el-button>-->
<!--                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>-->
<!--              </el-form-item>-->
<!--  </el-form>-->
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addEduExampaperCategory"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editEduExampaperCategory(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteEduExampaperCategory(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
<!--            <el-upload v-if="this.isImportDate"-->
<!--              class="upload-demo"-->
<!--              action="#"-->
<!--                            :http-request="upload"-->
<!--              :show-file-list="true">-->
<!--              <el-button size="small" type="primary">点击上传</el-button>-->
<!--              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>-->
<!--            </el-upload>-->
<!--        <span-->
<!--          title="搜索"-->
<!--          class="icon-box"-->
<!--          @click="search"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <Search />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="导出数据"-->
<!--          class="icon-box"-->
<!--          @click="exportEduExampaperCategoryList"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshEduExampaperCategoryList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="eduExampaperCategoryList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        prop="categoryName"
        label="名称"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="parentId"
        label="父级分类"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="sort"
        label="排序"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkEduExampaperCategory(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editEduExampaperCategory(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteEduExampaperCategory(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
              <div @click="addChildCourseCategory(scop.row.id)">
                  <Icon size="16">
                      <Eye24Regular />
                  </Icon>
                  <span class="operation-label">添加下级分类</span>
              </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
<!--    <div class="pagination-box">-->
<!--      <el-pagination-->
<!--        @size-change="sizeChange"-->
<!--        @current-change="currentChange"-->
<!--        :current-page.sync="currentPage"-->
<!--        :page-sizes="[10, 20, 50, 100]"-->
<!--        :page-size="pageSize"-->
<!--        layout="total, sizes, prev, pager, next, jumper"-->
<!--        :total="totalNum"-->
<!--        background-->
<!--        :pager-count="7"-->
<!--      >-->
<!--      </el-pagination>-->
<!--    </div>-->
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="eduExampaperCategoryStates[eduExampaperCategoryState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="eduExampaperCategory"
          ref="eduExampaperCategoryForm"
          :rules="rules"
          label-width="80px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="名称"
            prop="categoryName"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="eduExampaperCategory.categoryName"
              :disabled="eduExampaperCategoryState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="父级分类"
            prop="parentId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduExampaperCategory.parentId"-->
<!--              :disabled="eduExampaperCategoryState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  clearable
                  style="width: 177px"
                  :disabled="eduExampaperCategoryState == 'check'"
                  v-model="eduExampaperCategory.parentId"
                  placeholder="请选择"
                  size="small"
              >
                  <el-tree
                      :data="eduExampaperCategoryList"
                      :props="treeProps"
                      :render-after-expand="false"
                  >
                      <div
                          class="custom-tree-node flex items-center"
                          slot-scope="{ node, data }"
                      >
                          <el-option
                              :label="node.label"
                              :value="data.id"
                          > </el-option>
                      </div>
                  </el-tree>
              </el-select>
          </el-form-item>
          <el-form-item
            label="排序"
            prop="sort"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduExampaperCategory.sort"-->
<!--              :disabled="eduExampaperCategoryState == 'check'"-->
<!--            ></el-input>-->
              <el-input-number
                  style="width: 177px"
                  :disabled="eduExampaperCategoryState == 'check'"
                  v-model="eduExampaperCategory.sort"
                  size="small"
                  label=""
                  :min="1"
                  :max="100000"
                  :step="1"
                  :controls="true"
                  controls-position="both"
              >
              </el-input-number>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="eduExampaperCategoryState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetEduExampaperCategoryList();
                    this.getEduExampaperCategoryList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetEduExampaperCategoryList();
                    this.getEduExampaperCategoryList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     categoryName: '', //名称
                     parentId: '', //父ID
                     sort: '', //排序
                },
                treeProps: {
                    children: 'children',
                    label: 'categoryName'
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 1,
                currentUserId: '',
                eduExampaperCategoryState: 'add',
                eduExampaperCategoryStates: {
                    add: '新建试卷分类',
                    check: '查看试卷分类',
                    edit: '修改试卷分类'
                },

                multipleSelection: [],
                eduExampaperCategoryList: [],
                eduExampaperCategory: {
                    id: '', //
                    categoryName: '', //名称
                    parentId: '', //父ID
                    sort: '', //排序
                },
                btnLoading: false,

                rules: {
                    categoryName: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
                    // parentId: [{ required: true, message: '父ID不能为空', trigger: 'blur' }],
                    sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getEduExampaperCategoryList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            addChildCourseCategory(id){
                this.addEduExampaperCategory()
                this.eduExampaperCategory.parentId = id
            },
            resetEduExampaperCategoryList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.eduExampaperCategoryList = [];
            },
            resetDialog() {
                this.eduExampaperCategoryState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      categoryName: '', //名称
                      parentId: '', //父ID
                      sort: '', //排序
                };
                this.getEduExampaperCategoryList();
            },
            closeDialog() {
                this.showDialog = false
                this.eduExampaperCategory = {
                      id: '', //
                      categoryName: '', //名称
                      parentId: '', //父ID
                      sort: '', //排序
                };
            },
            submitForm() {
                if (this.eduExampaperCategoryState == 'add') {
                    this.$refs.eduExampaperCategoryForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/edu/exampapercategory/add`,{ ...this.eduExampaperCategory }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetEduExampaperCategoryList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.eduExampaperCategoryState == 'edit') {
                    this.$refs.eduExampaperCategoryForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.eduExampaperCategory.children;
                            post(`/edu/exampapercategory/edit`,{ ...this.eduExampaperCategory }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetEduExampaperCategoryList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addEduExampaperCategory() {
                this.showDialog = true;
                this.eduExampaperCategoryState = 'add';
            },
            checkEduExampaperCategory(eduExampaperCategoryId) {
                console.log(eduExampaperCategoryId);
                this.currentEduExampaperCategoryId = eduExampaperCategoryId;

                this.getEduExampaperCategoryById();
                this.showDialog = true;
                this.eduExampaperCategoryState = 'check';
            },
            editEduExampaperCategory(eduExampaperCategoryId) {
                console.log('eduExampaperCategory', eduExampaperCategoryId);
                if (eduExampaperCategoryId) {
                    this.currentEduExampaperCategoryId = eduExampaperCategoryId;
                    this.getEduExampaperCategoryById();
                } else {
                    this.eduExampaperCategory = { ...this.eduExampaperCategory, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.eduExampaperCategoryState = 'edit';
            },
            deleteEduExampaperCategory(eduExampaperCategoryId) {
                let ids = '';
                if (eduExampaperCategoryId) {
                    ids = eduExampaperCategoryId;
                } else {
                    ids = this.multipleSelection.map((eduExampaperCategory) => eduExampaperCategory.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/edu/exampapercategory/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetEduExampaperCategoryList();
                                this.getEduExampaperCategoryList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshEduExampaperCategoryList() {
                this.resetEduExampaperCategoryList();
                this.getEduExampaperCategoryList();
            },
            getEduExampaperCategoryList(query = {}) {
                this.loading = true;
                get(`/edu/exampapercategory/findAllAsTree`,{  ...this.queryForm }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.eduExampaperCategoryList = res.treeData;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getEduExampaperCategoryById() {
                get(`/edu/exampapercategory/get`,{ id: this.currentEduExampaperCategoryId }).then((res) =>{
                    if(res.success){
                      this.eduExampaperCategory = { ...this.eduExampaperCategory, ...res.eduExampaperCategory };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportEduExampaperCategoryList() {
                //this.btnLoading = true;
                exprotExcel(`/edu/exampapercategory/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/edu/exampapercategory/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/edu/exampapercategory/importData`,formData);
              this.refreshEduExampaperCategoryList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getEduExampaperCategoryList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getEduExampaperCategoryList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>